module.exports = __webpack_public_path__ + "img/disable_on_256x256.419d26b4.png";